var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"margin":"0","justify-content":"center"}},[(_vm.icon)?_c('v-icon',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('span',{staticClass:"d-none d-sm-flex pl-2"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }